import { CustomerBrandingDTO } from "../DTO/customerBrandingDTO";

export class CustomerBranding{
    public id!: number;
    public customerId!: number;
    public brandName!: string;
    public businessDisplayName!: string;
    public primaryColor!: string;
    public filePath!: string;

    public static mapFromDTO(param: CustomerBrandingDTO): CustomerBranding{
        if(!param) throw new Error("parameter is null")
        let obj = new CustomerBranding();
        try{
            obj.id = param.id;
            obj.customerId = param.customerId;
            obj.brandName = param.brandName;
            obj.businessDisplayName = param.businessDisplayName;
            obj.primaryColor = param.primaryColor;
            obj.filePath = param.filePath;
        }
        catch(e){
            console.log(e);
        }
        return obj;
    }

    public static mapToDTO(param: CustomerBranding):CustomerBrandingDTO{
        if(!param) throw new Error("parameter is null")
        let dto = new CustomerBrandingDTO();
        try {
            dto.id = param.id;
            dto.customerId = param.customerId;
            dto.brandName = param.brandName;
            dto.businessDisplayName = param.businessDisplayName;
            dto.primaryColor = param.primaryColor;
            dto.filePath = param.filePath;
        } 
        catch (e) {
            console.log(e);
        }
        return dto;
    }
}